<template>
  <v-btn
    :color="color"
    variant="outlined"
    :disabled="disabled"
    :loading="loading"
    class="text-none px-6"
    :class="{
      'rounded-pill': shape === 'pill',
      'rounded-lg': shape === 'box',
    }"
    @click="emitClick"
  >
    <slot></slot>
  </v-btn>
</template>
<script setup lang="ts">
interface Props {
  loading?: boolean
  disabled?: boolean
  shape?: 'box' | 'pill'
  color?: string
}

const { loading = false, disabled = false, shape = 'pill', color = 'pwt_palatinate_blue' } = defineProps<Props>()

const emit = defineEmits(['click'])

function emitClick() {
  emit('click')
}
</script>
